import moment from 'moment'
import React from 'react'
import { i18n } from '../../index'
import css from './feelingMeterNotesTable.css'
type FeelingsMeterAnswersTableProps = {
  answers: any[]
  question: string
}

const FeelingsMeterAnswersTable = (props: FeelingsMeterAnswersTableProps) => {
  const { answers, question } = props
  return answers.length > 0 ? (
    <div>
      <h3>{question}</h3>
      <table className={css.table}>
        <thead>
          <tr>
            <th>{i18n.t('reporting.label.feelingMeterNotes.station')}</th>
            <th>{i18n.t('reporting.label.feelingMeterNotes.name')}</th>
            <th>{i18n.t('reporting.label.feelingMeterNotes.date')}</th>
            <th>{i18n.t('reporting.label.feelingMeterNotes.answer')}</th>
          </tr>
        </thead>
        <tbody>
          {answers.map((answer, i) => (
            <tr key={i}>
              <td>{answer.station.name}</td>
              <td>{answer.user.name}</td>
              <td>{moment(Number(answer.date)).format('DD.MM.YYYY')}</td>
              <td>{answer.answer}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className={css.noNotes}>{i18n.t('reporting.label.feelingMeterNotes.noNotes')}</div>
  )
}

export default FeelingsMeterAnswersTable
